import { FC, useEffect } from 'react';
import { PageTitle, Page, SeoBlock } from '@edikk-edikk/country-layout-black';
import { ContentLoader } from '@edikk-edikk/country-common';
import { setError } from '@edikk-edikk/redux';
import { ApiError } from '@edikk-edikk/network-service';
import { useAdvertListData } from '@edikk-edikk/country-frontend';
import { CatalogByDate, CatalogByService } from '#advertList/components';
import { useInit } from '#advertList/hooks';
import { Filter } from '#advertList/components/filter/Filter';
import { AdvertListContext } from '#advertList/contexts/AdvertListContext';
import { AdvertListContextType } from '#advertList/contexts/AdvertListContextType';
import { AdvertListMetaData } from '#advertList/components/AdvertListMetaData';
import { useAppDispatch } from '#components/redux/hooks';
import { StoryList } from '#advert/modules/story/list';

type PropsType = {
  categoryId?: number;
  cityId?: number;
  areaId?: number;
};

const List: FC<PropsType> = ({
  categoryId = undefined,
  cityId = undefined,
  areaId = undefined,
}) => {
  const init = useInit(categoryId, cityId, areaId);
  const {
    data,
    advertDataListByDate,
    advertDataListByService,
    isFetching,
    isLoading,
    isError,
    error,
  } = init();
  const advertListData = useAdvertListData();
  const dispatch = useAppDispatch();

  if (ApiError.check(error)) {
    dispatch(setError(error));
  }

  useEffect(() => {
    advertListData.setCategoryId(categoryId).setCityId(cityId).setAreaId(areaId);

    return () => {
      advertListData.truncate();
    };
  }, [categoryId, cityId, areaId, advertListData]);

  if (isLoading) {
    return <ContentLoader />;
  }

  if (isError) {
    return null;
  }

  const advertListContextValue: AdvertListContextType = {
    storyDataList: data.storyDataList,
    filterData: data.filterData,
    advertDataListByDate,
    advertDataListByService,
    seo: data.seo,
    categoryId,
    cityId,
    areaId,
    isFetching,
  };

  return (
    <AdvertListContext value={advertListContextValue}>
      <AdvertListMetaData />
      <Page dataAttributeList={{ categoryId, cityId, areaId }}>
        <StoryList storyDataList={data.storyDataList} />
        <PageTitle title={data.seo.h1} />
        <Filter />
        <CatalogByDate />
        <CatalogByService />
        <SeoBlock text={data.seo.text} categoryList={data.seo.categoryList} cityList={data.seo.cityList} />
      </Page>
    </AdvertListContext>
  );
};

export default List;
